import { seo as seoAction } from '../constants/actionTypes';

export const initialState = {
  dramaInfo: {}
}

const seo = (state = initialState, action) => {
  switch(action.type) {
    case seoAction.FETCH_DRAMA_SEO_INFO:
      return {
        dramaInfo: action.data        
      }

    default:
      return state
  }
}

export default seo;
